module.exports = __webpack_public_path__ + "img/baipei1.9e9a1348.jpg";